export default __webpack_public_path__ + "9d6dff06979fa932852121addab58902.woff";